import Backbone from "backbone";

export default Backbone.Model.extend({
    urlRoot: "appSelects",
    idAttribute: "_id",
});

